module.exports = __webpack_public_path__ + "img/tjuvochpolis.3be5331c.jpg";